<main class="main">
  <div class="main-content">
    
    <!-- Header della pagina -->
    <div class="details-header">
      <div class="header-info">
        <button class="back-button" (click)="goBack()">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div class="title-section">
          <h1 class="main-title" *ngIf="manifestDetail">{{ manifestDetail.summary.title }}</h1>
          <h1 class="main-title" *ngIf="!manifestDetail">{{ 'DETAILS.TITLE' | translate }}</h1>
          <p class="main-subtitle" *ngIf="manifestDetail">{{ manifestDetail.summary.description }}</p>
          <p class="main-subtitle" *ngIf="!manifestDetail">{{ 'DETAILS.LOADING' | translate }}</p>
        </div>
      </div>
        <!-- Azioni dell'header -->
      <div class="header-actions" *ngIf="manifestDetail">
        <!-- Quick Add Input per aggiungere bolle al manifesto -->
        <div class="quick-add">
          <input type="text" class="form-control" placeholder="Aggiungi Bolla automaticamente al Borderò" />
          <button class="btn btn-primary">Aggiungi</button>
        </div>

        <button class="action-btn secondary" (click)="printManifest()">
          <i class="fas fa-print"></i>
          <span class="action-text">{{ 'DETAILS.ACTIONS.PRINT' | translate }}</span>
        </button>
        <button class="action-btn secondary" (click)="emailManifest()">
          <i class="fas fa-envelope"></i>
          <span class="action-text">{{ 'DETAILS.ACTIONS.EMAIL' | translate }}</span>
        </button>
        <button class="action-btn primary" (click)="configureManifest()">
          <i class="fas fa-cog"></i>
          <span class="action-text">{{ 'DETAILS.ACTIONS.SETTINGS' | translate }}</span>
        </button>
      </div>
    </div>    <!-- Contenuto principale -->
    <div *ngIf="manifestDetail; else loadingState" class="details-content">      
      <!-- Panel con riassunto manifest -->
      <div class="summary-panel card">
        <div class="card-header">
          <div class="header-title">
            <i class="fas fa-file-alt header-icon"></i>
            <h3>{{ 'DETAILS.SUMMARY.TITLE' | translate }}</h3>
          </div>
          <div class="header-badge">
            <span class="status-badge" [ngClass]="manifestDetail.summary.status.toLowerCase()">
              {{ manifestDetail.summary.status }}
            </span>
          </div>
        </div>

        <div class="card-content">
          <!-- Grid con informazioni principali -->
          <div class="summary-grid">
            <div class="summary-card info-card">
              <div class="card-icon">
                <i class="fas fa-info-circle"></i>
              </div>
              <div class="card-info">
                <h4>{{ 'DETAILS.SUMMARY.GENERAL_INFO' | translate }}</h4>
                <div class="info-list">
                  <div class="info-item">
                    <span class="info-label">{{ 'DETAILS.SUMMARY.DATE' | translate }}:</span>
                    <span class="info-value">{{ manifestDetail.summary.date | date:'dd/MM/yyyy' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ 'DETAILS.SUMMARY.WAREHOUSE' | translate }}:</span>
                    <span class="info-value">{{ manifestDetail.summary.warehouse }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ 'DETAILS.SUMMARY.DESTINATION' | translate }}:</span>
                    <span class="info-value">{{ manifestDetail.summary.location }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ 'DETAILS.SUMMARY.START_TIME' | translate }}:</span>
                    <span class="info-value">{{ manifestDetail.summary.timeStart }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="summary-card stats-card">
              <div class="card-icon">
                <i class="fas fa-chart-bar"></i>
              </div>
              <div class="card-info">
                <h4>{{ 'DETAILS.SUMMARY.STATISTICS' | translate }}</h4>
                <div class="stats-grid">
                  <div class="stat-item">
                    <div class="stat-number">{{ manifestDetail.summary.waybills }}</div>
                    <div class="stat-label">{{ 'DETAILS.SUMMARY.WAYBILLS' | translate }}</div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-number">{{ manifestDetail.summary.parcels }}</div>
                    <div class="stat-label">{{ 'DETAILS.SUMMARY.PARCELS' | translate }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="summary-card notes-card" *ngIf="manifestDetail.summary.note && manifestDetail.summary.note.length > 0">
              <div class="card-icon">
                <i class="fas fa-sticky-note"></i>
              </div>
              <div class="card-info">
                <h4>{{ 'DETAILS.SUMMARY.NOTES' | translate }}</h4>
                <p class="note-text">{{ manifestDetail.summary.note }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>      <!-- Panel con lista waybills -->
      <div class="waybills-panel card">
        <div class="card-header">
          <div class="header-title">
            <i class="fas fa-shipping-fast header-icon"></i>
            <h3>{{ 'DETAILS.WAYBILLS.TITLE' | translate }}</h3>
            <span class="waybills-count">{{ manifestDetail?.waybills?.length || 0 }}</span>
          </div>          <div class="header-actions">
            <div class="search-bar">
              <i class="fas fa-search search-icon"></i>
              <input type="text" class="form-control" placeholder="{{ 'DETAILS.WAYBILLS.SEARCH' | translate }}"
                [(ngModel)]="searchQuery" (input)="filterWaybills()" />
            </div>
          </div>
        </div>        <div class="card-content">
          <!-- Lista waybills -->          <div class="waybills-list" *ngIf="filteredWaybills && filteredWaybills.length > 0">            <div *ngFor="let waybill of filteredWaybills" class="waybill-item">
              <div class="waybill-card">
                <div class="waybill-header" (click)="toggleWaybill(getWaybillDisplayCode(waybill))">
                  <div class="waybill-icon">
                    <i class="fas fa-box"></i>
                  </div>
                  <div class="waybill-info">
                    <div class="waybill-code">{{ getWaybillDisplayCode(waybill) }}</div>
                    <div class="waybill-shipment">{{ waybill.waybillShipmentCode }}</div>
                    <div class="waybill-destination">{{ getWaybillDestination(waybill) }}</div>
                  </div>
                  <div class="waybill-stats">
                    <div class="stat-badge" [ngClass]="getWaybillStatusClass(waybill)">
                      {{ waybill.waybillStatus }}
                    </div>
                    <div class="delivery-method" *ngIf="waybill.waybillDeliveryMethod">
                      <span class="badge bg-info">{{ getDeliveryMethodDisplay(waybill) }}</span>
                    </div>
                  </div>
                  <div class="waybill-toggle">
                    <i class="fas" [ngClass]="expandedWaybills.has(getWaybillDisplayCode(waybill)) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </div>
                </div>                <!-- Dettagli waybill espandibili -->
                <div *ngIf="expandedWaybills.has(getWaybillDisplayCode(waybill))" class="waybill-details">
                  <div class="details-grid">
                    <div class="detail-item">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.WAYBILL_CODE' | translate }}</span>
                      <span class="detail-value">{{ waybill.waybillCode }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.SHIPMENT_CODE' | translate }}</span>
                      <span class="detail-value">{{ waybill.waybillShipmentCode }}</span>
                    </div>
                    <div class="detail-item" *ngIf="waybill.waybillPalletCode">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.PALLET_CODE' | translate }}</span>
                      <span class="detail-value">{{ waybill.waybillPalletCode }}</span>
                    </div>
                    <div class="detail-item" *ngIf="waybill.waybillTrackingNumber">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.TRACKING_NUMBER' | translate }}</span>
                      <span class="detail-value">{{ waybill.waybillTrackingNumber }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.ORIGIN_LOCATION' | translate }}</span>
                      <span class="detail-value">{{ getWaybillOrigin(waybill) }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.DESTINATION_LOCATION' | translate }}</span>
                      <span class="detail-value">{{ getWaybillDestination(waybill) }}</span>
                    </div>
                    <div class="detail-item" *ngIf="waybill.waybillLastKnownLocation">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.LAST_KNOWN_LOCATION' | translate }}</span>
                      <span class="detail-value">{{ waybill.waybillLastKnownLocation }}</span>
                    </div>
                    <div class="detail-item" *ngIf="waybill.waybillTotalWeight">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.TOTAL_WEIGHT' | translate }}</span>
                      <span class="detail-value">{{ getTotalWeight(waybill) }}</span>
                    </div>
                    <div class="detail-item" *ngIf="waybill.waybillTotalVolume">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.TOTAL_VOLUME' | translate }}</span>
                      <span class="detail-value">{{ getTotalVolume(waybill) }}</span>
                    </div>
                    <div class="detail-item" *ngIf="waybill.waybillEstimatedDeliveryDate">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.ESTIMATED_DELIVERY' | translate }}</span>
                      <span class="detail-value">{{ waybill.waybillEstimatedDeliveryDate | date:'dd/MM/yyyy' }}</span>
                    </div>
                    <div class="detail-item" *ngIf="waybill.waybillActualDeliveryDate">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.ACTUAL_DELIVERY' | translate }}</span>
                      <span class="detail-value">{{ waybill.waybillActualDeliveryDate | date:'dd/MM/yyyy HH:mm' }}</span>
                    </div>
                    <div class="detail-item" *ngIf="waybill.waybillDeliveryMethod">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.DELIVERY_METHOD' | translate }}</span>
                      <span class="detail-value">{{ getDeliveryMethodDisplay(waybill) }}</span>
                    </div>
                    <div class="detail-item" *ngIf="waybill.waybillDeliveryType">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.DELIVERY_TYPE' | translate }}</span>
                      <span class="detail-value">{{ waybill.waybillDeliveryType }}</span>
                    </div>
                    <div class="detail-item" *ngIf="waybill.waybillBrandCode">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.BRAND_CODE' | translate }}</span>
                      <span class="detail-value">{{ waybill.waybillBrandCode }}</span>
                    </div>
                    <div class="detail-item" *ngIf="waybill.waybillCarrierCode">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.CARRIER_CODE' | translate }}</span>
                      <span class="detail-value">{{ waybill.waybillCarrierCode }}</span>
                    </div>
                    <div class="detail-item" *ngIf="isWaybillFragile(waybill) || hasHazardousMaterial(waybill) || requiresCustomsClearance(waybill)">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.SPECIAL_HANDLING' | translate }}</span>
                      <div class="detail-value">
                        <span class="badge bg-warning me-1" *ngIf="isWaybillFragile(waybill)">
                          <i class="fas fa-exclamation-triangle"></i> {{ 'DETAILS.WAYBILLS.FRAGILE' | translate }}
                        </span>
                        <span class="badge bg-danger me-1" *ngIf="hasHazardousMaterial(waybill)">
                          <i class="fas fa-skull-crossbones"></i> {{ 'DETAILS.WAYBILLS.HAZARDOUS' | translate }}
                        </span>
                        <span class="badge bg-info" *ngIf="requiresCustomsClearance(waybill)">
                          <i class="fas fa-passport"></i> {{ 'DETAILS.WAYBILLS.CUSTOMS' | translate }}
                        </span>
                      </div>
                    </div>
                    <div class="detail-item" *ngIf="waybill.waybillNote">
                      <span class="detail-label">{{ 'DETAILS.WAYBILLS.NOTES' | translate }}</span>
                      <span class="detail-value">{{ waybill.waybillNote }}</span>
                    </div>
                  </div>                  <!-- Sezione colli - caricata dinamicamente -->
                  <div class="parcels-section">
                    <div class="section-header">
                      <h5>
                        <i class="fas fa-cube"></i>
                        {{ 'DETAILS.PARCELS.TITLE' | translate }}
                      </h5>
                      <button class="btn btn-sm btn-outline-primary" 
                              (click)="loadWaybillParcels(waybill.waybillCode)"
                              [disabled]="isParcelsLoading(waybill.waybillCode)"
                              *ngIf="!areParcelsLoaded(waybill.waybillCode)">
                        <i class="fas" [ngClass]="isParcelsLoading(waybill.waybillCode) ? 'fa-spinner fa-spin' : 'fa-download'"></i>
                        {{ isParcelsLoading(waybill.waybillCode) ? ('DETAILS.PARCELS.LOADING' | translate) : ('DETAILS.PARCELS.LOAD' | translate) }}
                      </button>
                    </div>
                    
                    <!-- Placeholder quando i parcels non sono caricati -->
                    <div class="parcels-placeholder" *ngIf="!areParcelsLoaded(waybill.waybillCode) && !isParcelsLoading(waybill.waybillCode)">
                      <div class="text-center text-muted py-3">
                        <i class="fas fa-box-open fa-2x mb-2"></i>
                        <div>{{ 'DETAILS.PARCELS.CLICK_TO_LOAD' | translate }}</div>
                      </div>
                    </div>
                    
                    <!-- Loading state -->
                    <div class="text-center py-3" *ngIf="isParcelsLoading(waybill.waybillCode)">
                      <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
                      <div class="mt-2">{{ 'DETAILS.PARCELS.LOADING' | translate }}</div>
                    </div>                    <!-- Griglia parcels quando sono caricati -->
                    <div class="parcels-grid" *ngIf="areParcelsLoaded(waybill.waybillCode) && getWaybillParcelsFromCache(waybill.waybillCode)!.length > 0">
                      <div *ngFor="let parcel of getWaybillParcelsFromCache(waybill.waybillCode)" class="parcel-card">                        <div class="parcel-header">
                          <span class="parcel-code">{{ parcel.parcelCode }}</span>
                          <span class="status-badge small" [ngClass]="parcel.parcelStatus?.toLowerCase()">
                            {{ parcel.parcelStatus }}
                          </span>
                        </div>
                        <div class="parcel-details">
                          <div class="parcel-info">
                            <div class="info-row">
                              <i class="fas fa-weight"></i>
                              <span>{{ parcel.parcelWeight }} kg</span>
                            </div>
                            <div class="info-row">
                              <i class="fas fa-ruler-combined"></i>
                              <span>{{ parcel.parcelLength }}x{{ parcel.parcelWidth }}x{{ parcel.parcelHeight }} cm</span>
                            </div>
                            <div class="info-row">
                              <i class="fas fa-tag"></i>
                              <span>{{ parcel.parcelType }}</span>
                            </div>
                            <div class="info-row">
                              <i class="fas fa-cube"></i>
                              <span>{{ parcel.parcelVolume }} m³</span>
                            </div>
                            <div class="info-row" *ngIf="parcel.parcelTrackingNumber">
                              <i class="fas fa-barcode"></i>
                              <span>{{ parcel.parcelTrackingNumber }}</span>
                            </div>
                          </div>
                          <div class="parcel-actions">
                            <button class="action-icon relabel-btn" title="{{ 'DETAILS.PARCELS.RELABEL' | translate }}" 
                                   (click)="relabelParcel(waybill, parcel.parcelCode, $event)">
                              <i class="fas fa-tags"></i>
                            </button>
                            <button class="action-icon remove-btn" title="{{ 'DETAILS.PARCELS.REMOVE' | translate }}" 
                                   (click)="removeParcel(waybill, parcel.parcelCode, $event)">
                              <i class="fas fa-trash-alt"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Messaggio quando non ci sono parcels -->
                    <div class="text-center text-muted py-3" *ngIf="areParcelsLoaded(waybill.waybillCode) && getWaybillParcelsFromCache(waybill.waybillCode)!.length === 0">
                      <i class="fas fa-inbox fa-2x mb-2"></i>
                      <div>{{ 'DETAILS.PARCELS.NO_PARCELS' | translate }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div><!-- Messaggio lista vuota o nessun risultato di ricerca -->
          <div *ngIf="!filteredWaybills || filteredWaybills.length === 0" class="empty-state">
            <div class="empty-icon">
              <i class="fas fa-shipping-fast"></i>
            </div>
            <!-- Mostra messaggio diverso se è una ricerca senza risultati -->
            <ng-container *ngIf="searchQuery && waybills.length > 0; else emptyWaybills">
              <h4>{{ 'DETAILS.WAYBILLS.NO_RESULTS_TITLE' | translate }}</h4>
              <p>{{ 'DETAILS.WAYBILLS.NO_RESULTS_MESSAGE' | translate: {query: searchQuery} }}</p>
              <button class="action-btn secondary" (click)="searchQuery = ''; filterWaybills()">
                <i class="fas fa-times"></i>
                {{ 'DETAILS.ACTIONS.CLEAR_SEARCH' | translate }}
              </button>
            </ng-container>
            
            <!-- Template per quando non ci sono waybill -->
            <ng-template #emptyWaybills>
              <h4>{{ 'DETAILS.WAYBILLS.EMPTY_TITLE' | translate }}</h4>
              <p>{{ 'DETAILS.WAYBILLS.EMPTY_MESSAGE' | translate }}</p>
              <button class="action-btn primary" (click)="addWaybill()">
                <i class="fas fa-plus"></i>
                {{ 'DETAILS.ACTIONS.ADD_WAYBILL' | translate }}
              </button>
            </ng-template>
          </div>
        </div>
      </div>    </div>

    <!-- Loading state -->
    <ng-template #loadingState>
      <div class="loading-state">
        <div class="loading-container">
          <div class="loading-spinner">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
          <h3>{{ 'DETAILS.LOADING' | translate }}</h3>
          <p>{{ 'DETAILS.LOADING_MESSAGE' | translate }}</p>
        </div>
      </div>
    </ng-template>
  </div>
</main>
